import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { NeptuneApi } from '../genericApi/neptune.api';
import { MultiBaseAbstractApi } from '../genericApi/multi-base-abstract.api';
import { BrandIdentityApi, BrandIdentityPayload } from './models/brand-identity.api.model';

@Injectable()
export class BrandIdentityApiService extends MultiBaseAbstractApi<BrandIdentityApi, BrandIdentityApi> {
    private readonly brandSlug: string = '/brandidentities';

    constructor(private neptuneApi: NeptuneApi) {
        super();
    }

    getList(): Observable<BrandIdentityApi[]> {
        return this.neptuneApi.api(
            this.brandSlug,
            null,
            HttpVerbsEnum.GET
        );
    }

    getById(id: number | string): Observable<BrandIdentityApi> {
        const slug = `${this.brandSlug}/${id}`;

        return this.neptuneApi.api(
            slug,
            null,
            HttpVerbsEnum.GET
        );
    }

    create(brand: BrandIdentityApi): Observable<number> {
        const payload = {
            ...brand,
            competitors: brand.competitors ? brand.competitors.filter(x => !x.id).map(x => x.name) : [],
            competitorIds: brand.competitors ? brand.competitors.filter(x => x.id).map(x => x.id) : [],
        } as BrandIdentityPayload;

        return this.neptuneApi.api(
            this.brandSlug,
            payload,
            HttpVerbsEnum.POST
        );
    }

    update(brand: BrandIdentityApi): Observable<number> {
        const slug = `${this.brandSlug}/${brand.id}`;
        const payload = {
            ...brand,
            competitors: brand.competitors ? brand.competitors.filter(x => !x.id).map(x => x.name) : [],
            competitorIds: brand.competitors ? brand.competitors.filter(x => x.id).map(x => x.id) : [],
        } as BrandIdentityPayload;

        return this.neptuneApi.api(
            slug,
            payload,
            HttpVerbsEnum.PUT
        ).pipe(map(() => brand.id));
    }

    deleteById(id: number): Observable<number> {
        const slug = `${this.brandSlug}/${id}`;

        return this.neptuneApi.api(
            slug,
            null,
            HttpVerbsEnum.DELETE
        );
    }
}
